export enum FormStatus {
  active = "active",
  inactive = "inactive",
}

export enum StatusOptions {
  active = "Активный",
  inactive = "Неактивный",
}
